import { render, staticRenderFns } from "./FuelingAct.vue?vue&type=template&id=5bcac220&scoped=true&"
import script from "./FuelingAct.vue?vue&type=script&lang=js&"
export * from "./FuelingAct.vue?vue&type=script&lang=js&"
import style0 from "./FuelingAct.vue?vue&type=style&index=0&id=5bcac220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcac220",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QItemSection,QItemLabel,QBtn,QTooltip,QChip,QAvatar,QCardActions,QInput,QIcon,QSelect,QExpansionItem,QCheckbox,QTable,QTr,QTh,QTd,QInnerLoading,QSpinnerGears,QDialog,ClosePopup,Ripple} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QItemSection,QItemLabel,QBtn,QTooltip,QChip,QAvatar,QCardActions,QInput,QIcon,QSelect,QExpansionItem,QCheckbox,QTable,QTr,QTh,QTd,QInnerLoading,QSpinnerGears,QDialog}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup,Ripple}, component.options.directives || {})
